/**
 * Error thrown by `authClient` when the API returns a non-2xx response.
 *
 * Carries the machine-readable `code` from the server's error envelope so
 * the dashboard's i18n layer can map it to a localized user-facing message
 * (see `apps/dashboard/src/i18n/en/errors.json` + `formatApiError` helper).
 *
 * The library NEVER calls `t()` itself (per
 * `aidlc-docs/construction/auth-workspaces-rbac/nfr-design/i18n-strategy.md § 8`);
 * the `message` field is the raw server message and serves as the last-ditch
 * fallback if a code mapping is missing.
 */
export class AuthClientError extends Error {
    /** HTTP status code returned by the API. */
    status;
    /** Machine-readable error code from the standard envelope (e.g., `NOT_FOUND`). */
    code;
    /** Request id returned by the API for log correlation. */
    requestId;
    /** Optional structured details from the envelope. */
    details;
    constructor(args) {
        super(args.message);
        this.name = "AuthClientError";
        this.status = args.status;
        this.code = args.code;
        this.requestId = args.requestId;
        this.details = args.details;
        Object.setPrototypeOf(this, AuthClientError.prototype);
    }
}
//# sourceMappingURL=auth-client-error.js.map